define('presentation/settings/liveReceptionistScripts/facades/liveReceptionistScriptsFacade',[
        'businessServices/authentication/sessionAccountInfo',
        'constants/liveReceptionistScriptConstants',
        'constants/referentialConstraintEnumerations',
        'externalDependencies/clientWebSocket',
        'presentation/common/dateTimeValue',
        'presentation/common/warningModal/presentationObjects/integrityWarningPresentationObject',
        'presentation/settings/liveReceptionistScripts/presentationObjects/liveReceptionistScriptsPresentationObject',
        'settings/navigationConfiguration'
    ],
    function() {
        const DateTimeValueConstructor = require('presentation/common/dateTimeValue');

        const LiveReceptionistScriptsPresentationObjectConstructor = require('presentation/settings/liveReceptionistScripts/presentationObjects/liveReceptionistScriptsPresentationObject');
        const _liveReceptionistScriptSocket = require('externalDependencies/clientWebSocket').forApplication("liveReceptionistScript");

        const IntegrityWarningPresentationObjectConstructor = require('presentation/common/warningModal/presentationObjects/integrityWarningPresentationObject');
        const integrityWarningMessagesEnumeration = require('constants/referentialConstraintEnumerations');

        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _liveReceptionistScriptConstants = require('constants/liveReceptionistScriptConstants');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

        let _promiseFactory = null;

        const filterLiveReceptionistScripts = (liveReceptionistScripts) => {
            if (_sessionAccountInfo.isImpersonating()) {
                return liveReceptionistScripts;
            }

            return liveReceptionistScripts.filter((liveReceptionistScript) => liveReceptionistScript.status !== _liveReceptionistScriptConstants.status.pending.id);
        };

        const _buildLiveReceptionistScriptPresentationObject = (liveReceptionistScript) => {
            const {liveReceptionistScriptId, name, status, type, createdDateTime, updatedDateTime} = liveReceptionistScript;
            let liveReceptionistScriptPresentationObject = new LiveReceptionistScriptsPresentationObjectConstructor();
            liveReceptionistScriptPresentationObject.liveReceptionistScriptId = liveReceptionistScriptId;
            liveReceptionistScriptPresentationObject.liveReceptionistScriptName = name;
            liveReceptionistScriptPresentationObject.status(status);
            liveReceptionistScriptPresentationObject.type(type);
            liveReceptionistScriptPresentationObject.createdDateTime = new DateTimeValueConstructor(createdDateTime);
            liveReceptionistScriptPresentationObject.updatedDateTime = new DateTimeValueConstructor(updatedDateTime);
            liveReceptionistScriptPresentationObject.editLiveReceptionistScriptUrl = _navigationConfiguration.routesById.editLiveReceptionistScript.baseUrl + liveReceptionistScriptId;
            return liveReceptionistScriptPresentationObject;
        };

        const _getLiveReceptionistScripts = () => {
            return _promiseFactory.defer((promise) => {
                _liveReceptionistScriptSocket.send("retrieveAll", {}, (response) => {
                    const liveReceptionistScripts = filterLiveReceptionistScripts(response);
                    const scripts = liveReceptionistScripts.map((liveReceptionistScript) => {
                        return _buildLiveReceptionistScriptPresentationObject(liveReceptionistScript);
                    });
                    promise.resolve(scripts);
                });
            });
        };

        const _getConstraints = (liveReceptionistScriptId) => {
            return _promiseFactory.defer((promise) => {
                _liveReceptionistScriptSocket.send("getConstraints", {liveReceptionistScriptId: liveReceptionistScriptId}, (constraints, err) => {
                    if (err) {
                        promise.reject(new Error(err));
                        return;
                    }
                    const integrityWarnings = getIntegrityWarnings(constraints);
                    promise.resolve(integrityWarnings);
                });
            });
        };

        const _deactivateLiveReceptionistScript = (liveReceptionistScriptId) => {
            return _promiseFactory.defer((promise) => {
                _liveReceptionistScriptSocket.send("deactivateLiveReceptionistScript", { liveReceptionistScriptId }, (response) => {
                    if (response.isSuccessful === false) {
                        promise.reject();
                        return;
                    }
                    promise.resolve();
                });
            });
        };

        const _reactivateLiveReceptionistScript = (liveReceptionistScriptId) => {
            return _promiseFactory.defer((promise) => {
                _liveReceptionistScriptSocket.send("reactivateLiveReceptionistScript", { liveReceptionistScriptId }, (response) => {
                    if (response.isSuccessful === false) {
                        promise.reject();
                        return;
                    }
                    promise.resolve();
                });
            });
        };

        const getIntegrityWarnings = (constraints) => {
            return constraints.map((constraint) => {
                const constraintType = constraint.parentType + '-' + constraint.referencedType;
                if (integrityWarningMessagesEnumeration[constraintType]) {
                    const integrityWarning = new IntegrityWarningPresentationObjectConstructor();
                    integrityWarning.entityText = integrityWarningMessagesEnumeration[constraintType].entityText;
                    integrityWarning.entityName = constraint.name;
                    integrityWarning.icon = integrityWarningMessagesEnumeration[constraintType].icon;
                    integrityWarning.message = integrityWarningMessagesEnumeration[constraintType].message;
                    return integrityWarning;
                }
            });
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;
        };

        const _dispose = () => {
            _liveReceptionistScriptSocket.disposeOfEvents();
        };

        return function() {
            const self = this;

            self.init = _init;
            self.dispose = _dispose;

            self.deactivateLiveReceptionistScript = _deactivateLiveReceptionistScript;
            self.getAllLiveReceptionistScripts = _getLiveReceptionistScripts;
            self.getConstraints = _getConstraints;
            self.reactivateLiveReceptionistScript = _reactivateLiveReceptionistScript;
        };
    });

